<template>
  <div>
  <b-modal
    ref="modalConferencia"
    id="modal-conferencia-compra"
    title="Conferência Física de Etiquetas"
    size="xl"
    dialog-class="modal-xxl"
    header-bg-variant="dark"
    header-text-variant="white"
    no-close-on-backdrop
    body-class="p-0"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <div class="modal-icon-header mr-3">
            <i class="fa fa-barcode"></i>
          </div>
          <div>
            <h5 class="mb-0 text-white font-weight-bold">Conferência de Carga XML</h5>
            <small class="text-light opacity-75">Compra #{{ compraId }} - {{ fornecedorNome }}</small>
          </div>
        </div>
        <b-button size="sm" variant="link" class="text-white" @click="close()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>
    </template>

    <div class="modal-body-premium">
      <div :class="['banner-status', `banner-status--${bannerStatus.variant}`]">
        {{ bannerStatus.text }}
      </div>
      <b-row no-gutters>
        <!-- COLUNA ESQUERDA: COLETA E RESUMO -->
        <b-col lg="8" class="border-right">
          <div class="p-4 h-100 bg-light">
            <!-- INPUT DE SCAN -->
            <div class="scan-section mb-4 shadow-sm">
              <!-- Toggle Avulso -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <label class="scan-label mb-0">
                  <template v-if="modoAvulso">Etiqueta Avulsa — preencha os dados e escaneie</template>
                  <template v-else>Aguardando leitura do código de barras...</template>
                </label>
                <button
                  type="button"
                  :class="['avulso-toggle', modoAvulso ? 'avulso-toggle--active' : '']"
                  @click="toggleModoAvulso"
                  :disabled="loading"
                >
                  <i :class="modoAvulso ? 'fa fa-times mr-1' : 'fa fa-plus mr-1'"></i>
                  {{ modoAvulso ? 'Cancelar Avulso' : 'Etiqueta Avulsa' }}
                </button>
              </div>

              <!-- Formulário Avulso -->
              <div v-if="modoAvulso" class="avulso-form mb-3">
                <b-row>
                  <!-- Produto -->
                  <b-col cols="12" class="mb-2">
                    <label class="avulso-label">Código do Produto <span class="text-danger">*</span></label>
                    <div class="d-flex gap-2">
                      <input
                        v-model="avulso.produtoId"
                        type="text"
                        class="avulso-input"
                        placeholder="Código interno..."
                        @blur="buscarProduto"
                        @keyup.enter="buscarProduto"
                        :disabled="loadingColeta"
                      />
                      <button type="button" class="avulso-search-btn" @click="abrirPesquisaProduto" :disabled="loadingColeta" title="Pesquisar produto pelo nome">
                        <i class="fa fa-search"></i>
                      </button>
                      <div class="avulso-produto-nome">
                        <b-spinner v-if="buscandoProduto" small variant="primary" />
                        <span v-else-if="produtoEncontrado" class="text-success font-weight-bold">
                          <i class="fa fa-check mr-1"></i>{{ produtoEncontrado }}
                        </span>
                        <span v-else-if="avulso.produtoId" class="text-danger font-xs">
                          <i class="fa fa-exclamation-triangle mr-1"></i>Produto não encontrado
                        </span>
                        <span v-else class="text-muted font-xs">Digite o código e pressione Tab ou Enter</span>
                      </div>
                    </div>
                  </b-col>

                  <!-- Data Produção + Data Validade -->
                  <b-col cols="6" class="mb-2">
                    <label class="avulso-label">Data de Produção <span class="text-danger">*</span></label>
                    <cec-input-data
                      :value="avulso.dataProducao"
                      @input="avulso.dataProducao = $event"
                      placeholderText="DD/MM/AAAA"
                      :disabled="loadingColeta"
                      input-class="avulso-input"
                    />
                  </b-col>
                  <b-col cols="6" class="mb-2">
                    <label class="avulso-label">Data de Validade <span class="text-danger">*</span></label>
                    <cec-input-data
                      :value="avulso.dataValidade"
                      @input="avulso.dataValidade = $event"
                      placeholderText="DD/MM/AAAA"
                      :disabled="loadingColeta"
                      input-class="avulso-input"
                    />
                  </b-col>

                  <!-- Peso + Peças + Peças/Caixa -->
                  <b-col cols="12" md="6" lg="3" class="mb-2">
                    <label class="avulso-label">Peso L&iacute;quido <span class="text-danger">*</span></label>
                    <input
                      v-model="avulso.peso"
                      type="number"
                      step="0.001"
                      min="0.001"
                      class="avulso-input"
                      placeholder="0.000"
                      :disabled="loadingColeta"
                    />
                  </b-col>
                  <b-col cols="12" md="6" lg="3" class="mb-2">
                    <label class="avulso-label">Peso Bruto <span class="text-danger">*</span></label>
                    <input
                      v-model="avulso.pesoBruto"
                      type="number"
                      step="0.001"
                      min="0.001"
                      class="avulso-input"
                      placeholder="0.000"
                      :disabled="loadingColeta"
                    />
                  </b-col>
                  <b-col cols="12" md="6" lg="3" class="mb-2">
                    <label class="avulso-label">Nº de Peças <span class="text-danger">*</span></label>
                    <input
                      v-model="avulso.pecas"
                      type="number"
                      min="1"
                      class="avulso-input"
                      placeholder="1"
                      :disabled="loadingColeta"
                    />
                  </b-col>
                  <b-col cols="12" md="6" lg="3" class="mb-2">
                    <label class="avulso-label">Peças/Caixa</label>
                    <input
                      v-model="avulso.pecasCaixa"
                      type="number"
                      min="1"
                      class="avulso-input"
                      placeholder="Opcional"
                      :disabled="loadingColeta"
                    />
                  </b-col>
                </b-row>
                <div class="avulso-hint">
                  <i class="fa fa-info-circle mr-1"></i>
                  Após preencher os dados, escaneie o código de barras. Produto e datas são mantidos para agilizar múltiplas unidades.
                  <button type="button" class="avulso-limpar-btn ml-2" @click="limparFormAvulso">
                    <i class="fa fa-eraser mr-1"></i>Limpar tudo
                  </button>
                </div>
              </div>

              <!-- Input de Barcode -->
              <div class="scan-input-wrap">
                <i class="fa fa-barcode scan-icon"></i>
                <input
                  ref="barcodeInput"
                  v-model="barcode"
                  class="scan-input"
                  :placeholder="modoAvulso ? 'Escaneie o código de barras da etiqueta avulsa...' : 'Escaneie a etiqueta aqui...'"
                  @keyup.enter="modoAvulso ? registrarColetaAvulsa() : registrarColeta()"
                  :disabled="loading"
                  autocomplete="off"
                />
                <b-spinner v-if="loadingColeta" small variant="primary" class="scan-spinner" />
              </div>
              <div v-if="ultimaEtiqueta" class="last-scan-feedback mt-2">
                <i class="fa fa-check-circle text-success mr-2"></i>
                <span>Último coletado: <strong>{{ ultimaEtiqueta.PRODUTO }}</strong> - {{ ultimaEtiqueta.PESO }}kg</span>
                <b-badge v-if="ultimaEtiqueta.AVULSA" variant="warning" class="ml-2 font-xs">AVULSA</b-badge>
              </div>
            </div>

            <!-- RESUMO POR PRODUTO -->
            <div class="summary-section bg-white rounded-lg p-3 shadow-xs border">
              <h6 class="section-title mb-3">
                <i class="fa fa-list-alt mr-2 text-primary"></i>Resumo da Conferência
              </h6>
              <b-table
                :items="resumoItens"
                :fields="camposResumo"
                small striped hover borderless
                class="mb-0 table-modern"
              >
                <template #cell(PROGRESSO)="{ item }">
                  <div class="d-flex align-items-center gap-2">
                    <template v-if="item.TOTAL !== null">
                      <b-progress :value="item.CONFERIDO" :max="item.TOTAL || 1" height="8px" class="flex-grow-1 rounded-pill" :variant="item.CONFERIDO >= item.TOTAL ? 'success' : 'primary'" />
                      <span class="font-xs font-weight-bold text-muted">{{ item.CONFERIDO }} / {{ item.TOTAL }}</span>
                    </template>
                    <template v-else>
                      <b-badge variant="warning" pill class="mr-1">{{ item.CONFERIDO }}</b-badge>
                      <span class="font-xs text-warning font-weight-bold">avulso(s)</span>
                    </template>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </b-col>

        <!-- COLUNA DIREITA: LOG DE LEITURA -->
        <b-col lg="4">
          <div class="p-0 d-flex flex-column h-100" style="max-height: 70vh;">
            <div class="p-3 bg-dark text-white d-flex justify-content-between align-items-center">
              <h6 class="mb-0 font-weight-bold"><i class="fa fa-history mr-2 text-warning"></i>Sequência de Leitura</h6>
              <b-badge variant="warning" pill>{{ etiquetasColetadas.length }}</b-badge>
            </div>
            
            <div class="flex-grow-1 overflow-auto p-2 bg-white">
              <div v-if="etiquetasColetadas.length === 0" class="text-center p-5 text-muted">
                <i class="fa fa-inbox fa-3x mb-3 opacity-25"></i>
                <p>Nenhuma etiqueta coletada ainda.</p>
              </div>
              <div v-else>
                <div v-for="(etiqueta, idx) in etiquetasColetadasOrdenadas" :key="etiqueta.ID" class="log-item shadow-xs">
                  <div class="log-item__left">
                    <div class="log-item__seq">#{{ etiquetasColetadasOrdenadas.length - idx }}</div>
                  </div>
                  <div class="log-item__info">
                    <div class="log-item__prod">
                      {{ etiqueta.DESCRICAO }}
                      <b-badge v-if="etiqueta.OP_PESAGEM_MANUAL === '1'" variant="warning" class="ml-1 log-avulsa-badge">AVULSA</b-badge>
                    </div>
                    <div class="log-item__meta">
                      <span><i class="fa fa-balance-scale mr-1"></i>{{ etiqueta.PESO }}kg</span>
                      <span class="ml-2"><i class="fa fa-tag mr-1"></i>{{ etiqueta.CODIGO_BARRAS.slice(-6) }}</span>
                    </div>
                  </div>
                  <div class="log-item__right">
                    <div class="log-item__weight">{{ formatarQuantidade(etiqueta.PESO) }}</div>
                    <button
                      type="button"
                      class="log-item__del-btn"
                      @click.stop="excluirEtiqueta(etiqueta)"
                      title="Excluir etiqueta"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-between w-100 align-items-center">
        <div class="text-muted font-xs">
          <i class="fa fa-info-circle mr-1"></i> Todas as etiquetas escaneadas são salvas automaticamente.
        </div>
        <div>
          <b-button variant="outline-danger" class="px-4" @click="fechar">
            SAIR
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>

  <!-- Modal de Pesquisa de Produto -->
  <b-modal
    id="modal-pesquisa-produto-conferencia"
    title="Pesquisar Produto"
    size="lg"
    hide-footer
    @shown="$nextTick(() => $refs.pesquisaInput && $refs.pesquisaInput.focus())"
  >
    <div class="d-flex gap-2 mb-3">
      <b-form-input
        ref="pesquisaInput"
        v-model="pesquisaProduto.termo"
        placeholder="Digite o nome ou parte do nome do produto..."
        @keyup.enter="executarPesquisaProduto"
      />
      <b-button variant="primary" @click="executarPesquisaProduto" :disabled="pesquisaProduto.carregando">
        <b-spinner v-if="pesquisaProduto.carregando" small />
        <i v-else class="fa fa-search"></i>
        Pesquisar
      </b-button>
    </div>
    <b-table
      v-if="pesquisaProduto.resultados.length > 0"
      :items="pesquisaProduto.resultados"
      :fields="[{ key: 'CODIGO', label: 'Código' }, { key: 'DESCRICAO', label: 'Produto' }]"
      hover striped small show-empty
      empty-text="Nenhum produto encontrado"
      @row-clicked="selecionarProdutoPesquisa"
      style="cursor: pointer"
    />
    <b-alert v-else-if="pesquisaProduto.pesquisado && !pesquisaProduto.carregando" show variant="info" class="mt-2">
      Nenhum produto encontrado para "{{ pesquisaProduto.termo }}".
    </b-alert>
  </b-modal>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  name: 'CompraConferenciaModal',
  components: { CecInputData },
  props: {
    compraId: { type: [Number, String], required: true }
  },
  data() {
    return {
      loading: false,
      loadingColeta: false,
      bannerStatus: {
        text: 'PRONTO PARA COLETA',
        variant: 'warning'
      },
      barcode: '',
      modoAvulso: false,
      buscandoProduto: false,
      produtoEncontrado: '',
      avulso: {
        produtoId: '',
        dataProducao: '',
        dataValidade: '',
        peso: '',
        pesoBruto: '',
        pecas: '',
        pecasCaixa: ''
      },
      fornecedorNome: '',
      resumo: [],
      etiquetas: [],
      ultimaEtiqueta: null,
      pesquisaProduto: {
        termo: '',
        resultados: [],
        carregando: false,
        pesquisado: false
      },
      camposResumo: [
        { key: 'DESCRICAO', label: 'Produto' },
        { key: 'PROGRESSO', label: 'Conferido', thClass: 'text-center' }
      ]
    }
  },
  computed: {
    etiquetasColetadas() {
      // Status 8 ou 2 (caso já estivesse concluída mas aberta para correção)
      return this.etiquetas.filter(e => e.SITUACAO === '8' || e.SITUACAO === '2')
    },
    etiquetasColetadasOrdenadas() {
      return [...this.etiquetasColetadas].sort((a, b) => b.SEQUENCIA_EMBARQUE - a.SEQUENCIA_EMBARQUE)
    },
    resumoItens() {
      return this.resumo
    }
  },
  methods: {
    abrir() {
      this.$bvModal.show('modal-conferencia-compra')
      this.carregarDados()
    },
    fechar() {
      this.$bvModal.hide('modal-conferencia-compra')
    },
    onModalShown() {
      this.focarInput()
    },
    onModalHidden() {
      this.$emit('closed')
    },
    focarInput() {
      this.$nextTick(() => {
        if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus()
      })
    },
    async carregarDados() {
      this.loading = true
      try {
        const response = await this.$http.get(`/api/protected/terminal/compra/getDadosTerminalByPedidoId/${this.compraId}`)
        // O retorno do terminal é { pedido, itens, etiquetas, resumo }
        this.etiquetas = response.data.etiquetas || []
        
        // Mapear o resumo para bater com o que precisamos (Previsto vs Coletado)
        // Usaremos 'itens' para o Previsto e 'resumo' para o Coletado
        const itensPrevistos = response.data.itens || []
        const resumoColetado = response.data.resumo || []
        
        this.resumoItensMapeado(itensPrevistos, resumoColetado)
        
        if (response.data.pedido && response.data.pedido.length > 0) {
          this.fornecedorNome = response.data.pedido[0].NOME_FORNECEDOR || ''
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao carregar dados da compra')
      } finally {
        this.loading = false
      }
    },
    resumoItensMapeado(previstos, coletados) {
      // Map planned items
      const produtosPrevistos = new Set(previstos.map(p => p.PRODUTO_ID))
      this.resumo = previstos.map(p => {
        const coletado = coletados.find(c => c.PRODUTO_ID === p.PRODUTO_ID) || { PECAS: 0 }
        return {
          PRODUTO_ID: p.PRODUTO_ID,
          DESCRICAO: p.NOME_PRODUTO,
          TOTAL: p.QT_PECAS,
          CONFERIDO: coletado.PECAS
        }
      })
      // Add avulso-only products not in planned items
      coletados.forEach(c => {
        if (!produtosPrevistos.has(c.PRODUTO_ID)) {
          this.resumo.push({
            PRODUTO_ID: c.PRODUTO_ID,
            DESCRICAO: c.DESCRICAO,
            TOTAL: null,
            CONFERIDO: c.PECAS
          })
        }
      })
    },
    async registrarColeta() {
      if (!this.barcode || this.loadingColeta) return
      
      const b = this.barcode.trim()
      this.barcode = ''
      this.loadingColeta = true
      
      try {
        const response = await this.$http.post('/api/protected/compra/conferencia/registrar-coleta', {
          pedidoCompraId: this.compraId,
          codigoBarras: b,
          login: window.localStorage.getItem('login')
        })
        
        if (response.data.sucesso) {
          this.ultimaEtiqueta = { ...response.data.etiqueta, AVULSA: false }
          this.bannerStatus = {
            text: `${this.ultimaEtiqueta.PRODUTO}: ${this.formatarQuantidade(this.ultimaEtiqueta.PESO)}`,
            variant: 'success'
          }
          Tools.exibirMensagem(this.$store, 'Coletado', 'success', `OK: ${this.ultimaEtiqueta.PRODUTO}`)
          await this.carregarDados()
          this.tocarSomSucesso()
        }
      } catch (err) {
        const msg = err.response?.data || (typeof err === 'string' ? err : err.message) || 'Erro ao registrar'
        this.bannerStatus = {
          text: msg.toUpperCase(),
          variant: 'danger'
        }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', err)
        this.tocarSomErro()
      } finally {
        this.loadingColeta = false
        this.focarInput()
      }
    },
    toggleModoAvulso() {
      this.modoAvulso = !this.modoAvulso
      if (!this.modoAvulso) this.limparFormAvulso()
      this.$nextTick(() => this.focarInput())
    },
    limparFormAvulso() {
      this.avulso = { produtoId: '', dataProducao: '', dataValidade: '', peso: '', pesoBruto: '', pecas: '', pecasCaixa: '' }
      this.produtoEncontrado = ''
      this.barcode = ''
    },
    async buscarProduto() {
      const codigo = String(this.avulso.produtoId || '').trim()
      if (!codigo) { this.produtoEncontrado = ''; return }
      this.buscandoProduto = true
      this.produtoEncontrado = ''
      try {
        const response = await this.$http.get(`/api/protected/compra/conferencia/produto/${codigo}`)
        this.produtoEncontrado = response.data.DESCRICAO
      } catch {
        this.produtoEncontrado = ''
      } finally {
        this.buscandoProduto = false
      }
    },
    async registrarColetaAvulsa() {
      if (!this.barcode || this.loadingColeta) return
      if (!this.avulso.produtoId) {
        this.bannerStatus = { text: 'INFORME O PRODUTO', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o código do produto')
        this.tocarSomErro(); return
      }
      if (!this.produtoEncontrado) {
        this.bannerStatus = { text: 'PRODUTO NÃO ENCONTRADO', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Produto não encontrado — verifique o código')
        this.tocarSomErro(); return
      }
      if (!this.avulso.dataProducao) {
        this.bannerStatus = { text: 'INFORME A DATA DE PRODUÇÃO', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a data de produção')
        this.tocarSomErro(); return
      }
      if (!this.avulso.dataValidade) {
        this.bannerStatus = { text: 'INFORME A DATA DE VALIDADE', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a data de validade')
        this.tocarSomErro(); return
      }
      if (!this.avulso.peso || Number(this.avulso.peso) <= 0) {
        this.bannerStatus = { text: 'INFORME O PESO LIQUIDO', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atencao', 'warning', 'Informe o peso liquido da etiqueta')
        this.tocarSomErro(); return
      }
      if (!this.avulso.pesoBruto || Number(this.avulso.pesoBruto) <= 0) {
        this.bannerStatus = { text: 'INFORME O PESO BRUTO', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o peso bruto da etiqueta')
        this.tocarSomErro(); return
      }
      if (Number(this.avulso.pesoBruto) < Number(this.avulso.peso)) {
        this.bannerStatus = { text: 'PESO BRUTO MENOR QUE O LIQUIDO', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atencao', 'warning', 'O peso bruto nao pode ser menor que o peso liquido')
        this.tocarSomErro(); return
      }
      if (!this.avulso.pecas || Number(this.avulso.pecas) <= 0) {
        this.bannerStatus = { text: 'INFORME O Nº DE PEÇAS', variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o número de peças')
        this.tocarSomErro(); return
      }

      const b = this.barcode.trim()
      this.barcode = ''
      this.loadingColeta = true

      try {
        const response = await this.$http.post('/api/protected/compra/conferencia/registrar-coleta-avulsa', {
          pedidoCompraId: this.compraId,
          produtoId: this.avulso.produtoId,
          codigoBarras: b,
          peso: this.avulso.peso,
          pesoBruto: this.avulso.pesoBruto,
          pecas: this.avulso.pecas,
          pecasCaixa: this.avulso.pecasCaixa || null,
          dataProducao: this.avulso.dataProducao,
          dataValidade: this.avulso.dataValidade,
          login: window.localStorage.getItem('login')
        })

        if (response.data.sucesso) {
          this.ultimaEtiqueta = { ...response.data.etiqueta, AVULSA: true }
          this.bannerStatus = {
            text: `AVULSA: ${this.ultimaEtiqueta.PRODUTO} — ${this.formatarQuantidade(this.ultimaEtiqueta.PESO)}`,
            variant: 'success'
          }
          Tools.exibirMensagem(this.$store, 'Avulsa Registrada', 'success', `OK: ${this.ultimaEtiqueta.PRODUTO}`)
          await this.carregarDados()
          this.tocarSomSucesso()
        }
      } catch (err) {
        const msg = err.response?.data || (typeof err === 'string' ? err : err.message) || 'Erro ao registrar'
        this.bannerStatus = { text: msg.toUpperCase(), variant: 'danger' }
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', err)
        this.tocarSomErro()
      } finally {
        this.loadingColeta = false
        this.focarInput()
      }
    },
    async finalizar() {
      const confirm = await this.$bvModal.msgBoxConfirm(
        'Deseja finalizar a conferência? Todas as etiquetas coletadas serão liberadas para venda.',
        {
          title: 'Finalizar Conferência',
          okTitle: 'SIM, FINALIZAR',
          cancelTitle: 'CANCELAR',
          okVariant: 'success',
          centered: true
        }
      )
      
      if (!confirm) return
      
      this.loading = true
      try {
        const response = await this.$http.post('/api/protected/compra/conferencia/finalizar', {
          pedidoCompraId: this.compraId,
          login: window.localStorage.getItem('login')
        })
        
        if (response.data.sucesso) {
          Tools.exibirMensagem(this.$store, 'Concluído', 'success', 'Compra conferida e estoque liberado!')
          this.$emit('concluido')
          this.fechar()
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
      } finally {
        this.loading = false
      }
    },
    tocarSomSucesso() {
      const Audio = window.Audio
      const audio = new Audio('/static/media/sucesso.wav')
      audio.play().catch(() => {})
    },
    tocarSomErro() {
      const Audio = window.Audio
      const audio = new Audio('/static/media/error.wav')
      audio.play().catch(() => {})
    },
    formatarQuantidade(v) {
      return Tools.formatarQuantidade(v)
    },
    abrirPesquisaProduto() {
      this.pesquisaProduto.termo = ''
      this.pesquisaProduto.resultados = []
      this.pesquisaProduto.pesquisado = false
      this.$bvModal.show('modal-pesquisa-produto-conferencia')
    },
    async executarPesquisaProduto() {
      const termo = (this.pesquisaProduto.termo || '').trim()
      if (!termo || termo.length < 2) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe ao menos 2 caracteres para pesquisar')
        return
      }
      this.pesquisaProduto.carregando = true
      this.pesquisaProduto.pesquisado = false
      try {
        const response = await this.$http.get('/api/protected/compra/conferencia/produtos/pesquisar', {
          params: { nome: termo }
        })
        this.pesquisaProduto.resultados = response.data || []
        this.pesquisaProduto.pesquisado = true
      } catch {
        this.pesquisaProduto.resultados = []
        this.pesquisaProduto.pesquisado = true
      } finally {
        this.pesquisaProduto.carregando = false
      }
    },
    selecionarProdutoPesquisa(produto) {
      this.avulso.produtoId = String(produto.CODIGO)
      this.produtoEncontrado = produto.DESCRICAO
      this.$bvModal.hide('modal-pesquisa-produto-conferencia')
      this.$nextTick(() => this.focarInput())
    },
    async excluirEtiqueta(etiqueta) {
      const tipo = (etiqueta.OP_PESAGEM_MANUAL === '1' && (etiqueta.CODIGO_INTERNO === '0' || !etiqueta.CODIGO_INTERNO)) ? 'avulsa' : 'XML'
      const confirm = await this.$bvModal.msgBoxConfirm(
        `Deseja excluir a etiqueta ${tipo === 'avulsa' ? 'AVULSA' : ''} de "${etiqueta.DESCRICAO}" (${etiqueta.PESO}kg)?` +
        (tipo === 'avulsa' ? '\nA etiqueta será excluída fisicamente.' : '\nA etiqueta voltará ao status de aguardando coleta.'),
        {
          title: 'Excluir Etiqueta',
          okTitle: 'SIM, EXCLUIR',
          cancelTitle: 'CANCELAR',
          okVariant: 'danger',
          centered: true
        }
      )
      if (!confirm) return

      this.loadingColeta = true
      try {
        await this.$http.delete(
          `/api/protected/compra/conferencia/etiqueta/${etiqueta.ID}`,
          { params: { pedidoCompraId: this.compraId } }
        )
        Tools.exibirMensagem(this.$store, 'Excluído', 'success', 'Etiqueta removida com sucesso')
        this.tocarSomSucesso()
        await this.carregarDados()
      } catch (err) {
        const msg = err.response?.data || (typeof err === 'string' ? err : err.message) || 'Erro ao excluir'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', msg)
      } finally {
        this.loadingColeta = false
        this.focarInput()
      }
    }
  }
}
</script>

<style scoped>
.modal-body-premium {
  min-height: 500px;
}

.modal-icon-header {
  width: 42px; height: 42px;
  background: rgba(255,255,255,0.1);
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 20px;
}

/* SCAN SECTION */
.scan-section {
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  border: 2px solid #eef2ff;
}
.scan-label { font-size: 0.85rem; font-weight: 600; color: #64748b; margin-bottom: 12px; display: block; }
.scan-input-wrap { position: relative; }
.scan-icon { position: absolute; left: 20px; top: 50%; transform: translateY(-50%); font-size: 24px; color: #6366f1; }
.scan-input {
  width: 100%; height: 64px;
  background: #f8fafc; border: 2px solid #e2e8f0; border-radius: 14px;
  padding: 0 60px 0 60px; font-size: 1.5rem; font-weight: 700;
  color: #1e293b; transition: all 0.2s;
}
.scan-input:focus {
  background: #fff; border-color: #6366f1; box-shadow: 0 0 0 5px rgba(99, 102, 241, 0.1); outline: none;
}
.scan-spinner { position: absolute; right: 20px; top: 50%; transform: translateY(-50%); }

.last-scan-feedback { font-size: 0.9rem; animation: fadeIn 0.3s; }

/* SUMMARY TABLE */
.section-title { font-size: 0.85rem; font-weight: 700; color: #1e293b; text-transform: uppercase; letter-spacing: 0.05em; }
.table-modern { font-size: 0.9rem; }
.table-modern th { border: none !important; color: #64748b; font-weight: 600; }
.font-xs { font-size: 0.75rem; }

/* LOG ITEMS */
.log-item {
  display: flex; align-items: center; gap: 15px;
  padding: 15px; background: #f8fafc; border-radius: 16px;
  margin-bottom: 12px; border: 1px solid #f1f5f9;
  animation: slideInRight 0.3s ease-out;
  transition: all 0.2s;
}
.log-item:hover { transform: translateX(-5px); background: #fff; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }

.log-item__left { flex-shrink: 0; }
.log-item__seq {
  width: 44px; height: 44px;
  background: #1e293b; color: #fff;
  display: flex; align-items: center; justify-content: center;
  border-radius: 12px; font-weight: 800; font-size: 0.95rem;
}

.log-item__info { flex-grow: 1; }
.log-item__prod { font-weight: 800; color: #1e293b; font-size: 0.95rem; margin-bottom: 2px; text-transform: uppercase; }
.log-item__meta { font-size: 0.8rem; color: #64748b; font-weight: 500; display: flex; align-items: center; }
.log-avulsa-badge { font-size: 0.65rem; vertical-align: middle; }

.log-item__right { flex-shrink: 0; text-align: right; }
.log-item__weight {
  font-size: 1.8rem; font-weight: 800; color: #4338ca;
  letter-spacing: -0.02em; line-height: 1;
}

@keyframes slideInRight {
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

.opacity-75 { opacity: 0.75; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
.gap-2 { gap: 8px; }

/* AVULSO TOGGLE */
.avulso-toggle {
  display: inline-flex; align-items: center;
  padding: 7px 18px;
  background: #f1f5f9; border: 2px solid #e2e8f0;
  border-radius: 30px; font-size: 0.82rem; font-weight: 700;
  color: #475569; cursor: pointer; transition: all 0.2s;
  white-space: nowrap;
}
.avulso-toggle:hover { background: #e2e8f0; border-color: #cbd5e1; color: #1e293b; }
.avulso-toggle--active {
  background: #fff3cd; border-color: #f59e0b;
  color: #92400e;
}
.avulso-toggle--active:hover { background: #fde68a; }

/* AVULSO FORM */
.avulso-form {
  background: #fffbeb;
  border: 2px solid #fde68a;
  border-radius: 14px;
  padding: 18px 18px 10px;
  animation: fadeIn 0.25s ease-out;
}
.avulso-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #78350f;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: block;
  margin-bottom: 4px;
}
.avulso-input {
  width: 100%;
  height: 38px;
  background: #fff;
  border: 1.5px solid #fcd34d;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
  transition: all 0.2s;
}
.avulso-input:focus {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
  outline: none;
}
.avulso-produto-nome {
  display: flex; align-items: center;
  min-height: 38px;
  padding: 0 8px;
  font-size: 0.875rem;
  white-space: nowrap;
}
.avulso-hint {
  font-size: 0.78rem;
  color: #92400e;
  background: #fef3c7;
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.avulso-limpar-btn {
  background: none; border: none;
  color: #b45309; font-size: 0.78rem; font-weight: 700;
  cursor: pointer; padding: 0 4px;
  text-decoration: underline;
}
.avulso-limpar-btn:hover { color: #92400e; }

/* BANNER STATUS */
.banner-status {
  padding: 15px 25px;
  font-size: 2.2rem;
  font-weight: 800;
  color: white;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
.banner-status--warning { background-color: #f59e0b; }
.banner-status--success { background-color: #10b981; }
.banner-status--danger { background-color: #ef4444; }

/* AVULSO - search button */
.avulso-search-btn {
  flex-shrink: 0;
  height: 38px;
  width: 38px;
  background: #fef3c7;
  border: 1.5px solid #fcd34d;
  border-radius: 8px;
  color: #92400e;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.2s;
}
.avulso-search-btn:hover { background: #fde68a; }
.avulso-search-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* LOG - delete button */
.log-item__del-btn {
  margin-top: 4px;
  background: none;
  border: none;
  color: #ef4444;
  font-size: 0.75rem;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  opacity: 0.5;
  transition: all 0.2s;
}
.log-item__del-btn:hover { opacity: 1; background: #fee2e2; }
.log-item__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* Força modal a ficar maior que XL */
@media (min-width: 1200px) {
  :deep(.modal-xxl) {
    max-width: 96vw !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/compras/CompraConferenciaModal.vue